<template>
  <div>
    <router-view></router-view>

    <van-tabbar v-model="active" fixed placeholder route>
      <van-tabbar-item  to="/index">
        <span>首页</span>
        <template #icon="props">
          <img :src="props.active ? icon.active : icon.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item to="/notbook">
        <span>不抢</span>
        <template #icon="props">
          <img :src="props.active ? icon3.active : icon3.inactive" />
        </template>
      </van-tabbar-item>
      <van-tabbar-item  to="/account">
        <span>待改价</span>
        <template #icon="props">
          <img :src="props.active ? icon2.active : icon2.inactive" />
        </template>
      </van-tabbar-item>
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: 'index',
      icon: {
        active: 'https://www.wechat.jiaowushu.com/xy_1.png',
        inactive: 'https://www.wechat.jiaowushu.com/xy_2.png'
      },
      icon2: {
        active: 'https://www.wechat.jiaowushu.com/kebiao.png',
        inactive: 'https://www.wechat.jiaowushu.com/kebiao_2.png'
      },
      icon3: {
        active: 'https://www.wechat.jiaowushu.com/my.png',
        inactive: 'https://www.wechat.jiaowushu.com/my_2.png'
      },
      icon4: {
        active: 'https://www.wechat.jiaowushu.com/quanzi.png',
        inactive: 'https://www.wechat.jiaowushu.com/quanzi_2.png'
      },
      icon5: {
        active: 'https://www.wechat.jiaowushu.com/message.png',
        inactive: 'https://www.wechat.jiaowushu.com/message_2.png'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.van-tabbar-item__icon img {
  height: 1.7rem;
}
</style>
